import Vue from 'vue';
import MerchantApplication from './merchant-application/merchant-application.vue';
Vue.component('merchant-application', MerchantApplication);
